export default __webpack_public_path__ + "cc98042dc968a3d63273893e631e25f4.png";